import React from 'react';
import ReactDOM from 'react-dom';
import App from 'src/App';
import reportWebVitals from 'src/reportWebVitals';
import 'src/index.scss';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

// ENV переменные
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED === 'true';
const SENTRY_TRACES_SAMPLE_RATE = Number(
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? 1
);
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'Development';
const GIT_BRANCH = process.env.REACT_APP_GIT_BRANCH || 'unknown-branch';

// Функция для очистки имени окружения Sentry
const getSentryEnvironment = (branch: string): string => {
  return branch
    .replace(/\//g, '-')   // Заменяем слэши на дефисы
    .replace(/\\/g, '-')   // Заменяем обратные слэши
    .toLowerCase()         // Приводим к нижнему регистру
    .replace(/^-+|-+$/g, '') // Убираем дефисы с начала и конца
    .substring(0, 64);     // Ограничиваем длину 64 символа
};

const sentryEnvironment = getSentryEnvironment(GIT_BRANCH);

if (
  SENTRY_ENABLED &&
  SENTRY_DSN &&
  SENTRY_DSN.startsWith('https://')
) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        tracingOrigins: [/^\//], // только внутренние запросы
      }),
    ],
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    environment: sentryEnvironment, // Используем ветку как environment
    release: `questionnaire-app-client-tests@1.0.0`, // Фиксированный релиз
    debug: GIT_BRANCH !== 'main', // Debug только не на main

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Network Error',
      'timeout of 0ms exceeded',
      'Script error.',
    ],

    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
    ],

    beforeSend(event) {
      // Добавляем теги
      event.tags = {
        ...event.tags,
        'git.branch': GIT_BRANCH,
        'app.environment': ENVIRONMENT,
        'application': 'test-client',
      };
      return event;
    },
  });

  // Отправляем сообщение о старте приложения
  Sentry.captureMessage(`Test Client application started. Git branch: ${GIT_BRANCH}`, {
    level: 'info' as Sentry.SeverityLevel,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();